module.exports = __webpack_public_path__ + "static/media/regione-autonoma-sardegna.1f167b2c.svg";